.label {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 400;
	text-align: center;
	margin: auto;
	padding-right: 0px !important;
	padding-left: 0px !important;

	.textTitle {
		width: 75%;
		display: inline-flex;
		justify-content: center;
	}
}

.iconArrow {
	width: 7px;
	fill: #bebdbe;
	cursor: pointer;
}

.iconArrowActive {
	width: 7px;
	fill: #8fc459;
	cursor: pointer;
}

.textTableHeader {
	margin-top: 5px;
	margin-bottom: 5px;
}
